import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService, SearchParams } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  Stores: BehaviorSubject<any> = new BehaviorSubject(null);
  StoresSmall: BehaviorSubject<any> = new BehaviorSubject(null);

  private _storesProcessing = false;

  // endpoints
  private _storesEp = `${this._apiSvc.endpoints.monolith}/api/Store`;

  constructor(
    private _apiSvc: ApiService
  ) { }

    /**
   * Get stores and return observable
   */
  getStoresAsync( searchParams?: SearchParams): Observable<any> {
    let params = null;
    if(!searchParams) {
      params = {
        sort: 'StoreRefCode-asc'
      };
    }
    else {
      params = searchParams;
    }
    return this._apiSvc.search(this._storesEp, params)
  }

  /**
   * Get stores
   */
  getStores(refresh: boolean = false): void {

    if (this._storesProcessing || (this.Stores.value && !refresh)) return;

    this._storesProcessing = true;

    const params = {
      sort: 'StoreRefCode-asc'
    };

    this._apiSvc.search(this._storesEp, params)
      .subscribe((res: any) => {
        this._storesProcessing = false;
        this.Stores.next(res.Data);
      }, () => {
        this._storesProcessing = false;
      });

  }

  /**
   * Get stores small
   */
  getStoresSmall(): void {

    this._apiSvc.get(`${this._storesEp}/small`)
      .subscribe((res: any) => {
        this.StoresSmall.next(res.Data);
      });

  }

  /**
   * Get store
   * @param storeRefId 
   */
  getStore(storeRefId: number): any {
    return this._apiSvc.get(`${this._storesEp}/${storeRefId}`);
  }

  updateFillOptions(payload: any) {
    return this._apiSvc.update(`${this._storesEp}/StoreAutoFillSettings`, payload);
  }

}
